import { render, staticRenderFns } from "./tag-details.vue?vue&type=template&id=af3e50d8&scoped=true"
import script from "./tag-details.vue?vue&type=script&lang=js"
export * from "./tag-details.vue?vue&type=script&lang=js"
import style0 from "./tag-details.vue?vue&type=style&index=0&id=af3e50d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3e50d8",
  null
  
)

export default component.exports